module.exports = __webpack_public_path__ + "static/media/19029_STENI_AnimasjonsfilmKonfigurator_30SEK_V04.0ea0c854.mp4";